import styled from 'styled-components';
import { lighten } from 'polished';
import ButtonCompactSecondary from 'components/atoms/buttons/compact/Secondary';

const AddButton = styled.button`
    background-color: transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    height: 40px; 
    padding: 0px 10px;
    font-size: 22px;
    color: ${props => props.theme.colors.primary}
`;

const RemoveButton = styled(AddButton)`
    color: ${props => props.theme.colors.flamepea};
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-direction: row;
    width: 75px;
    height: 90%;
`;

const AddNewButton = styled(ButtonCompactSecondary)`
    background-color: #fafafa;
    border: 1px solid ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
    padding: 10px;
  
    :hover {
        background-color: ${props => lighten(0.1, props.theme.colors.primary)};
        color: #fff;

        ::before {
            background-color: #fff;
            color: ${props => props.theme.colors.primary};
        }
    }

    ::before{
        display: inline-block;
        width: 20px;
        font-size: 17px;
        line-height: 22px;
        background-color: ${props => props.theme.colors.primary};
        border-radius: 20px;
        font-weight: bold;
        content: "+";
        color: #fff;
        margin-right: 3px;
    }
`;

const FieldWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export default { AddButton, AddNewButton, RemoveButton, ButtonWrapper, FieldWrapper };



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/ListOperations.js